export enum EventCategory {
    Live = 0,
    Complementary = 1,
    Monitoring = 2,
    VirtualRoom = 5
}
